import { notify } from "../../components/alerts";
import { IApiResponse } from "../../store/@types/api-response";
import { INotificationCount } from "../../store/@types/notifications";
import {
  setCount,
  setLoading,
  setNotification,
  setNotifications,
  setNotificationSeen,
  setShow,
  setUpdate,
} from "../../store/slices/notification";
import { AppDispatch } from "../../store/store";
import axiosInstance from "../../utils/axiosInstance";

const notificationEndpoint = "/api/v1/client/notifications";

export const get_notifications = async (
  dispatch: AppDispatch,
  limit: number,
  offset: number,
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(`${notificationEndpoint}`, {
      params: { limit, offset },
    });
    dispatch(setNotifications(response.data));
  } catch (error: any) {
    console.log(error?.response?.data);
  } finally {
    dispatch(setLoading(false));
  }
};

export const get_notification = async (dispatch: AppDispatch, id: number) => {
  dispatch(setShow());
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(`${notificationEndpoint}/${id}`);
    dispatch(setNotification(response.data));
  } catch (error: any) {
    console.log(error?.response?.data);
  } finally {
    dispatch(setLoading(false));
  }
  dispatch(setShow());
};

export const seen_notification = async (dispatch: AppDispatch, id: number) => {
  try {
    await axiosInstance.patch(`${notificationEndpoint}/${id}`);
    dispatch(setNotificationSeen(id));
  } catch (error: any) {
    console.log(error?.response?.data);
  }
};

export const get_counts = async (dispatch: AppDispatch) => {
  try {
    const response = await axiosInstance.get<IApiResponse<INotificationCount>>(
      `${notificationEndpoint}/counts`,
    );
    dispatch(setCount(response.data.data));
  } catch (error: any) {
    console.log(error?.response?.data);
  }
};

export const update_payment = async (
  dispatch: AppDispatch,
  formData: string,
) => {
  let result = false;
  dispatch(setUpdate());
  try {
    await axiosInstance.post("/verify-payment-request-service", formData);

    notify({ type: "success", message: `We will get back to you shortly.` });
    result = true;
  } catch (err) {
    // logger action
    result = false;
    notify({
      type: "error",
      message: `If you feel something is wrong please email us at account@corporate-setup.com.`,
    });
  }
  dispatch(setUpdate());
  return result;
};

export const update_price = async (dispatch: AppDispatch, formData: string) => {
  let result = false;
  dispatch(setUpdate());
  try {
    await axiosInstance.post("/budget-submitted-request-service", formData);

    notify({ type: "success", message: `We will get back to you shortly.` });
    result = true;
  } catch (err) {
    // logger action
    result = false;
    notify({
      type: "error",
      message: `If you feel something is wrong please email us at account@corporate-setup.com.`,
    });
  }
  dispatch(setUpdate());
  return result;
};
